import React, { useMemo } from 'react';
import { Box, Heading, Grid, useMediaQuery } from '@chakra-ui/react';
import ProjectCard from '../cards/ProjectCard';
import { Project } from '../../config/types';

interface ProjectsSectionProps {
  //activeProjects: Project[];
  upcomingProjects: Project[];
  studyProjects: Project[];
}

const ProjectsSection: React.FC<ProjectsSectionProps> = ({ /*activeProjects,*/ upcomingProjects, studyProjects }) => {
  // Usa useMediaQuery para aplicar estilos específicos para pantallas grandes
  const [isLaptopOrLarger] = useMediaQuery("(min-width: 992px)");

  // Combinar y aleatorizar todos los proyectos
  const randomizedProjects = useMemo(() => {
    const allProjects = [...upcomingProjects, ...studyProjects];
    return allProjects.sort(() => Math.random() - 0.5);
  }, [upcomingProjects, studyProjects]);

  return (
    <Box 
      w="100%" 
      py={10} 
      bgGradient="radial-gradient(circle at 0% 80%, #0ef1fa 0%, #0b4d78 100%)" // Background gradient
      color="gray.900" // Dark text color for better readability
    >
      <Box maxW="1200px" mx="auto" py={10} px={4} textAlign="center">
        <Heading 
          as="h2" 
          fontSize={isLaptopOrLarger ? "6xl" : "5xl"} 
          mb={isLaptopOrLarger ? 10 : 6} // Ajustar margen inferior según el tamaño de la pantalla
          color="white"
          paddingTop={isLaptopOrLarger ? "0" : "10px"} // Agregar espacio superior en pantallas más pequeñas
        >
          Algunos de nuestros trabajos
        </Heading>

        <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)' }} gap={6}>
          {randomizedProjects.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ProjectsSection;
